import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StorageS3HttpMethodsService } from '../storage-s3-http-methods.service';
import { StorageHsbshareHttpMethodsService } from '../storage-hsbshare-http-methods.service';
import { PathService } from '../path.service';

@Component({
  selector: 'app-cloud-folder-content',
  templateUrl: './cloud-folder-content.component.html',
  styleUrls: ['./cloud-folder-content.component.css']
})
export class CloudFolderContentComponent implements OnInit {

  @Output() fileSelected = new EventEmitter<any>();
  @Output() folderSelected = new EventEmitter<any>();


  selectedFileURL;

  pathcrumTrail =[];

  selectedFolder;
  selectedFile;
  
  selectedFileIndex = -1;

  files;
  folders;

  accessKeyId;
  secretAccessKey;
  rootContainer;//in S3: bucket, in hsbShare: ProjectName 
  rootContainerId;//in s3 bucket, in hsbShare: projectId

  currentPath = [];

  storageProvider;//supported: s3,hsbShare

  visible =false;

  constructor(private storageS3HttpMethodsService: StorageS3HttpMethodsService,
              private storageHsbshareHttpMethodsService: StorageHsbshareHttpMethodsService,
              private pathService: PathService) {

  }

  ngOnInit() {
    this.storageProvider = null;
    //this.selectS3Link('AKIAIMVKNEIZGS4LP7KQ','bJ481qSQSzzb7zs9hNXLqs2Z3EJyKQ+uYWr+oTyY','https://iohsbsharebucket.s3.amazonaws.com/Exporter/Input/all.hmm');
  }
  getBucketFromurl(url){
    var resArray = /https:\/\/(.*).s3.amazonaws.com/gi.exec(url);
    return resArray.length > 1 ? resArray[1] : '';
  }


  selectS3Link(accessKeyId, secretAccessKey, s3Link){
    this.rootContainer = this.getBucketFromurl(s3Link);
    let fullPath = s3Link.replace('https://'+this.rootContainer+'.s3.amazonaws.com/', '');
    if(fullPath.substr(fullPath.length - 1) === '/'){
      //directory
      var path = fullPath;
      this.listS3(accessKeyId, secretAccessKey, this.rootContainer, path)
        .then(data => {
          this.updateCrumbTrail(path);
          this.visible = true;
        }, error => {
          this.visible = false;
          console.log(error);
        });

    }else{
      //file
      var fileName = fullPath.split('/').pop();
      var path = fullPath.replace(fileName, '');
      this.listS3(accessKeyId, secretAccessKey, this.rootContainer, path)
        .then(data => {
          var selInd = -1;
          this.files.forEach((fName, i) => {
            if(fName.split('/').pop() === fileName){
              selInd = i;
            }
            if(selInd >=0){
              this.updateCrumbTrail(path);
              this.selectFile(fileName, selInd);
              
            }
            this.visible = true;
          });
        }, error => {
          this.visible = false;
            console.log(error);
        });
    }

  }

  listS3(accessKeyId, secretAccessKey, bucket, path) {
    this.storageProvider = 's3';
    return new Promise((resolve, reject) => {
      this.selectedFileIndex = -1;
      if(!this.rootContainer){
       this.pathcrumTrail =  [{folder: bucket, path:'/'}];
      }
  
      this.accessKeyId = accessKeyId;
      this.secretAccessKey = secretAccessKey;
      this.selectedFolder = path;
      this.rootContainer = bucket;
      this.rootContainerId = bucket;
  
      this.storageS3HttpMethodsService.ls(accessKeyId, secretAccessKey, bucket, path)
        .then(data => {
          if(!data){
            return reject('null data');
          }
          this.files = data.files;
          this.folders = data.folders;
          this.visible = true;
          this.updateCrumbTrail(this.selectedFolder);
          resolve(data);
        }).catch(error => {
          //if(error && error.code === "NoSuchBucket"){}
          this.visible = false;
          reject(error);
        });
    });
  }

  listHsbShare(projectId, projectName, relativePath /* path without /project/projectID */) {
    this.storageProvider = 'hsbShare';
    return new Promise((resolve, reject) => {
      this.selectedFileIndex = -1;
      if(!this.rootContainer){
       this.pathcrumTrail =  [{folder: this.rootContainer, path:'/'}];
      }
  
      this.selectedFolder = relativePath;
      this.rootContainer = projectName;
      this.rootContainerId = projectId;
  
      this.storageHsbshareHttpMethodsService.ls(projectId, relativePath)
        .then(data => {
          if(!data){
            return reject('null data');
          }
          this.files = data.files;
          this.folders = data.folders;
          this.visible = true;
          this.updateCrumbTrail(this.selectedFolder);
          resolve(data);
        }).catch(error => {
          //if(error && error.code === "NoSuchBucket"){}
          this.visible = false;
          reject(error);
        });
    });
  }

  openFolder(folder:string){
    this.updateCrumbTrail(folder);
    if(this.storageProvider === 's3'){
      this.selectedFileURL = 'https://'+this.rootContainer+'.s3.amazonaws.com/' + (folder != '/' ? folder : '');
      this.listS3(this.accessKeyId, this.secretAccessKey, this.rootContainer, this.selectedFolder)
        .then(data => {
          this.folderSelected.emit({selectedFolder: this.selectedFolder, selectedFileURL: this.selectedFileURL});
        }, error => console.error);
    } else if(this.storageProvider === 'hsbShare'){
      this.selectedFileURL = this.pathService.join('/projects/' , this.rootContainerId , (folder != '/' ? folder : ''));
      this.listHsbShare(this.rootContainerId, this.rootContainer, this.selectedFolder)
        .then(data => {
          this.folderSelected.emit({selectedFolder: this.selectedFolder, selectedFileURL: this.selectedFileURL});
        }, error => console.error);
    }
  }
  selectFile(file:string, index:number){
    this.selectedFile = file;
    if(this.storageProvider === 's3'){
      this.selectedFileURL = 'https://'+this.rootContainer+'.s3.amazonaws.com/' + file;
    } else if(this.storageProvider === 'hsbShare'){
      this.selectedFileURL = this.pathService.join('/projects/', this.rootContainerId ,file);
    }
    this.selectedFileIndex = index;
    this.fileSelected.emit({selectedFile: this.selectedFile, selectedFileURL: this.selectedFileURL});
  }
  getName(path){
    let pathArray = path.split('/');
    if(pathArray[pathArray.length - 1] === ''){
      pathArray.pop();
    }
    return pathArray.pop();
  }
  updateCrumbTrail(folder)
  {
    this.selectedFolder = folder;
    //let crum = this.selectedFolder.split('/').slice(0,-1).map((foldr, i, arr) => {return {
    let crum = this.selectedFolder.split('/').map((foldr, i, arr) => {return {  
      folder: foldr,
      path: arr.reduce((acc, foldr, index) => {
        if(index <= i){
          if(acc === ''){
            acc = foldr; 
          }else {
            acc = acc + '/' + foldr;
          }
        }
        return acc;
      },"") + '/'
    }});
    if(crum[0].folder === ""){ crum.shift(); }
    crum.splice(0, 0, {folder: this.rootContainer, path:'/'} );//insert as first element
    this.pathcrumTrail = crum.filter(c => c.folder !== '');
  }



}



// WEBPACK FOOTER //
// ./src/app/cloud-folder-content/cloud-folder-content.component.ts